/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";

import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import AddNotification from "./manageNotifications/add";
import NotificationDetail from "./manageNotifications/view";
import ManageStores from "./manageStores";
import AddStore from "./manageStores/add";
import StoreDetail from "./manageStores/view";
import ManageTransction from "./manage-transction";
import ViewTransction from "./manage-transction/viewTransction";
import Signup from "./auth/signup";
import SignupForm from "./auth/signup-form";
import ServiceListing from "./service-listings";
import AddService from "./service-listings/add";
import ViewService from "./service-listings/view";
import Portfolio from "./portfolio";
import AddPortfolio from "./portfolio/add";
import ViewPortfolio from "./portfolio/view";
import Chat from "./chat";
import Earnings from "./earnings";
import Bookings from "./bookings";
import AdminSupport from "./admin-support";
import CustomerSupport from "./customer-support";
import ViewAdminSupport from "./admin-support/view";
import Ratings from "./ratings";
import KnowledgeBase from "./admin-support/knowledgeBase";
import VideoTutorials from "./admin-support/videoTutorials";

export default {
  Login,
  Signup,
  SignupForm,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ViewAdminSupport,
  VideoTutorials,
  ManageNotifications,
  KnowledgeBase,
  AddNotification,
  NotificationDetail,
  RecievedNotifications,
  ManageProfile,
  Ratings,
  EditProfile,
  ChangePassword,
  ManageStores,
  AddStore,
  CustomerSupport,
  StoreDetail,
  ManageTransction,
  ServiceListing,
  AddService,
  ViewService,
  Portfolio,
  AddPortfolio,
  ViewPortfolio,
  Bookings,
  Chat,
  Earnings,
  ViewTransction,
  AdminSupport
};
